<div *ngIf="event" class="text-size">
    <div class="p-3  shadow-right rounded-1 min-vh-100">
        <div class="mb-4">
            <strong
                class="d-flex justify-content-start w-100 title-fs mb-3 text-slide-title">{{'MESSAGE_INFO.EVENT_DETAIL' |
                translate}}</strong>
            <div class="d-flex align-items-center">
                <mat-icon>keyboard_arrow_left</mat-icon>
                <a (click)="backToEventList()" class="cursor">
                    {{'BUTTONS.BACK' | translate}}
                </a>
            </div>
        </div>
        <hr>
        <div>
            <div class="border mt-2 p-2 rounded-1">
                <div class="row pb-2">
                    <div class="col-12 d-flex align-items-center">
                        <img src="./icon/project.svg" />
                        <span class="ms-2 fs-5 "> {{event.projetLabel }}</span><br>
                    </div>
                </div>
                <div class="row">
                    <div class="d-flex align-items-center ps-3" *ngIf="event.startDate != null">

                        <span>{{event.startDate | date:'yyyy-MM-dd'}} - {{event.endDate |
                            date:'yyyy-MM-dd'}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="d-flex align-items-center ps-3">
                        <span class="fs-5 fw-bold">{{event.name }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex align-items-center">
                        <img src="./icon/blastMenu.svg" />
                        <span class="ms-2 "> {{event.eventTypeLabel }}</span><br>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="d-flex justify-content-start gap-2">
                <button type="button" class="btn-sm report-button primary-button" (click)="downloadReport()">
                    <img src="icon/result.svg" /> <span class="text-size ms-1">{{'REPORT.REPORT' | translate}}</span>
                </button>

                <button type="button"
                    class="btn btn-light btn-sm border-color-button secondary-button detail-edit-button"
                    (click)="onModifyVibrationEvent()">
                    <img src="icon/edit-pencil.svg" /> {{'BUTTONS.MODIFY' | translate}}
                </button>

                <button type="button" class="tertiary-button delete-button" (click)="onDelete()">
                    <img src="icon/delete.svg" /> {{'BUTTONS.DELETE' | translate}}
                </button>
            </div>
        </div>

        <hr>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">Zone</div>
                <div>{{site?.region.nom}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">Site</div>
                <div>{{site?.nom}}</div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">X</div>
                <div>{{transformedCoords?.x}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">Y</div>
                <div>{{transformedCoords?.y}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div>
                    <div class="text-muted">Z</div>
                    <div>{{event.positionCoordinates?.z}}</div>
                </div>
            </div>
        </div>
    </div>
</div>